module.exports = __webpack_public_path__ + "img/dt_profile.ed93dfc2.png";